export const T = {
  en_GB: {
    saving: "Saving...",
    submit: "Submit",
    previewNotice: "This flow is in preview and can't be submitted yet.",
    welcome: "Welcome,",
  },
  nb_NO: {
    saving: "Lagrer...",
    submit: "Send inn",
    previewNotice: "Denne flyten er i forhåndsvisning og kan ikke sendes inn ennå.",
    welcome: "Velkommen,",
  },
} as const;
